import { Handle, Position } from 'reactflow';
import React from 'react';
import Alert from '@mui/material/Alert';

function PrometheusNode({ id, data }) {
    return (
        <>
            {data["parentNode"] === undefined &&
                <>
                    <Alert severity="warning">put me inside cluster :(</Alert>
                </>
            }
            <div style={{
                border: "1px black solid",
                padding: "1.2em 1.2em",
                display: 'flex'
            }}>
                <span> Prometheus Server</span>
                {data["parentNode"] != undefined && <>
                    <Handle
                        className="sourceHandle"
                        position={Position.Left}
                        type="target"
                    />
                    <Handle
                        className="targetHandle"
                        position={Position.Right}
                        type="source"
                        style={{
                            left: 167
                        }}
                    />
                </>}
            </div>
            {data && data.mode == "sidecar" &&
                <div style={{
                    borderBottom: "1px black solid",
                    borderLeft: "1px black solid",
                    borderRight: "1px black solid",
                    display: 'flex',
                    padding: "0.5em 1.8em",
                }}>
                    <span> Thanos Sidecar</span>
                </div>

            }



        </>
    );
}

export default PrometheusNode;